/*
 * @Descripttion: 日志上报文件
 * @Author: guoxt
 * @Date: 2023-03-20 13:48
 * @LastEditors: guoxt
 * @LastEditTime: 2023-03-20 13:48
 */
import FsLogger from '@fubei/mina-logger'
import getEnv from '../config/index'
const { APP_ID, LOG_PROJECT_NAME, LOG_SEEDS_STORE, VERSION } = getEnv()
console.log('VERSION: ', VERSION)
const logger = new FsLogger({
  project: LOG_PROJECT_NAME,
  logstore: LOG_SEEDS_STORE,
  time: 10, // 发送日志的时间间隔，默认是10秒
  count: 1, // 发送日志的数量大小，默认是10条
  sendSysInfo: true,
  data() {
    return {
      AppId: APP_ID,
      // AdLabel: wx._AgentData?.adLabel,
      // User: wx._AgentData?.adLabel,
      // OpenId: wx._AgentData?.openId,
      // OrderId: wx._AgentData?.orderId,
      // ClientSession: wx._AgentData?.traceId,
      Version: VERSION,
    }
  }
})

export default logger
